import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

export default function NotFoundPageEn() {
  return (
    <>
      <Helmet>
        <html lang="en" />
        <title>404 - Page Not Found | POVL MØLLERS MASKINFABRIK A/S</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>

      <section className="min-h-[70vh] flex items-center justify-center bg-stone-50 py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-xl mx-auto text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-[#006368]/10 text-[#006368] mb-6">
            <span className="text-3xl font-extrabold">404</span>
          </div>

          <h1 className="text-3xl sm:text-4xl font-extrabold text-stone-900 tracking-tight">
            Page Not Found
          </h1>
          <p className="mt-4 text-stone-600 text-sm sm:text-base leading-relaxed">
            The page you are looking for does not exist or may have been moved. Please use the navigation or return to our homepage.
          </p>

          <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
            <Link
              to="/en"
              className="px-6 py-3 rounded bg-[#006368] hover:bg-[#004d51] text-white font-semibold text-sm transition shadow-sm"
            >
              Go to Home
            </Link>
            <Link
              to="/en/contact"
              className="px-6 py-3 rounded border border-stone-300 bg-white hover:bg-stone-100 text-stone-800 font-semibold text-sm transition"
            >
              Contact us
            </Link>
          </div>

          <div className="mt-12 pt-8 border-t border-stone-200 text-left">
            <h3 className="text-xs font-bold uppercase tracking-wider text-stone-500 mb-3 text-center">
              Featured Machinery & Services
            </h3>
            <div className="flex flex-wrap justify-center gap-2">
              <Link
                to="/en/central-lubrication"
                className="px-3 py-1.5 rounded bg-white border border-stone-200 text-xs font-medium text-stone-700 hover:text-[#006368] hover:border-[#006368] transition"
              >
                Central Lubrication
              </Link>
              <Link
                to="/en/presses"
                className="px-3 py-1.5 rounded bg-white border border-stone-200 text-xs font-medium text-stone-700 hover:text-[#006368] hover:border-[#006368] transition"
              >
                Presses
              </Link>
              <Link
                to="/en/used-presses"
                className="px-3 py-1.5 rounded bg-white border border-stone-200 text-xs font-medium text-stone-700 hover:text-[#006368] hover:border-[#006368] transition"
              >
                Used Presses
              </Link>
              <Link
                to="/en/laser"
                className="px-3 py-1.5 rounded bg-white border border-stone-200 text-xs font-medium text-stone-700 hover:text-[#006368] hover:border-[#006368] transition"
              >
                Laser
              </Link>
              <Link
                to="/en/press-brakes"
                className="px-3 py-1.5 rounded bg-white border border-stone-200 text-xs font-medium text-stone-700 hover:text-[#006368] hover:border-[#006368] transition"
              >
                Press Brakes
              </Link>
              <Link
                to="/en/spare-parts"
                className="px-3 py-1.5 rounded bg-white border border-stone-200 text-xs font-medium text-stone-700 hover:text-[#006368] hover:border-[#006368] transition"
              >
                Spare Parts
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
